<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style scoped lang='stylus' rel='stylesheet/stylus'>
  #app
    position relative
    width 100%
    height 100%
    z-index 1
</style>



// WEBPACK FOOTER //
// src/App.vue